let listener = null;
let pending = null;

export const onReauthRequest = (fn) => { listener = fn; return () => { listener = null; }; };

export const requestReauth = () => {
  if (pending) return pending;
  pending = new Promise((resolve, reject) => {
    if (!listener) { reject(new Error("no reauth handler")); return; }
    listener({ resolve, reject });
  }).finally(() => { pending = null; });
  return pending;
};
